var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "model") && runtime.contextOrFrameLookup(context, frame, "showRemoveBtn")) {
output += "\n    <a href=\"\" js-remove-foreign-key-btn class=\"remove-btn icon-btn\">Remove</a>\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "model") && runtime.contextOrFrameLookup(context, frame, "showEditBtn")) {
output += "\n    <a href=\"\" js-edit-foreign-key-btn class=\"edit-foreign-key-btn icon-btn edit-btn\">Edit</a>\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "showAddBtn")) {
output += "\n    <a href=\"\" js-new-foreign-key-btn class=\"new-foreign-key-btn icon-btn add-btn\">New</a>\n";
;
}
output += "\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-buttons.html
// module chunks = main